import styled, { css } from 'styled-components';

export const WalletWrapper = styled.div`
  display: flex;
  padding: 16px 0;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  border-bottom: 1px solid black;
`;

export const Logo = styled.div`
  grid-area: logo;
  display: flex;
  align-items: center;
  & > span {
    margin-left: 16px;
  }
`;

export const Id = styled.div`
  grid-area: id;
`;

export const Derivation = styled.div`
  grid-area: der;
`;

export const Mnemonic = styled.div`
  ${({ isBlur }) => css`
    grid-area: mnen;
    display: flex;
    justify-content: space-around;
    & > button {
      max-width: 200px;
    }
    ${isBlur &&
    css`
      color: transparent;
      text-shadow: 0 0 8px rgba(0, 0, 0, 0.5);

      :hover {
        color: unset;
        text-shadow: unset;
      }
    `};
  `}
`;
